<template>
  <span class="switch-table-sort">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9.14 5.14" :style="stateStyle[state]">
        <g id="Слой_2" data-name="Слой 2">
          <g id="Слой_1-2" data-name="Слой 1">
            <path class="cls-1"
                  d="M9,1,5,5a.56.56,0,0,1-.8,0l-4-4A.54.54,0,0,1,0,.57.58.58,0,0,1,.57,0h8a.58.58,0,0,1,.57.57A.54.54,0,0,1,9,1Z"/>
          </g>
        </g>
      </svg>
  </span>
</template>

<script>
  export default {
    name: 'SwitchTableSort',
    props: {
      state: {
        default: 0
      },
    },
    data: () => ({
      stateStyle: {
        0: {
          transform: 'rotate(180deg)',
          opacity: '0.5'
        },
        1: {
          transform: 'rotate(180deg)',
        },
        2: {
          transform: 'rotate(360deg)',
        }
      }
    })
  }
</script>

<style scoped>
  .switch-table-sort {
    display: inline-block;
    padding: 5px;
    width: auto;
    position: relative;
  }

  .switch-table-sort svg {
    height: 14%;
    width: 10px
  }

  .cls-1 {
    fill: #424242;
  }
</style>
